/**
 * Prio+ is a checkout-only service. Hide the toggle without real products,
 * and drop Prio+ from the cart when the last real product is removed.
 */
(function () {
  'use strict';

  if (window.__mkCartPrioInit) return;
  window.__mkCartPrioInit = true;

  var CHECKBOX_ID = 'upsell-prioplus';
  var busy = false;
  var sweeping = false;

  function isHidden(item) {
    return !!(window.theme && theme.isHiddenService && theme.isHiddenService(item));
  }

  function productQty(cart) {
    if (!cart || !cart.items) return 0;
    var n = 0;
    for (var i = 0; i < cart.items.length; i++) {
      if (!isHidden(cart.items[i])) n += cart.items[i].quantity || 0;
    }
    return n;
  }

  function parseCartResponse(r) {
    return r.json().then(function (data) {
      if (!r.ok) throw new Error(data.description || data.message || 'cart error');
      return data;
    });
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(parseCartResponse);
  }

  function prioItems(cart) {
    var out = [];
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (isHidden(items[i])) out.push(items[i]);
    }
    return out;
  }

  function syncHeaderCount(cart) {
    var count = String(window.theme && typeof theme.cartVisibleQuantity === 'function'
      ? theme.cartVisibleQuantity(cart)
      : productQty(cart));
    document.querySelectorAll('.header-cart__count').forEach(function (el) {
      el.textContent = count;
    });
  }

  function syncUi(cart) {
    var visible = productQty(cart);
    var wrap = document.querySelector('.cart-prio-upselling');
    var checkbox = document.getElementById(CHECKBOX_ID);
    var prioInCart = prioItems(cart).length > 0;

    if (wrap) wrap.hidden = visible === 0;
    if (checkbox) {
      checkbox.checked = prioInCart;
      checkbox.disabled = visible === 0 || busy;
    }
    syncCartHint(visible > 0);
    syncHeaderCount(cart);
  }

  function syncCartHint(shouldShow) {
    var hint = document.getElementById('cart-hint');
    if (!hint) return;

    if (shouldShow) {
      if (hint.getAttribute('data-open') === '1') return;
      hint.setAttribute('data-open', '1');
      hint.hidden = false;
      hint.classList.remove('is-leaving');
      hint.classList.remove('is-in');
      void hint.offsetWidth;
      hint.classList.add('is-in');
      return;
    }

    if (hint.getAttribute('data-open') !== '1' && hint.hidden) return;
    hint.setAttribute('data-open', '0');
    hint.classList.remove('is-in');
    hint.classList.add('is-leaving');
    window.clearTimeout(hint._mkLeaveTimer);
    hint._mkLeaveTimer = window.setTimeout(function () {
      if (hint.getAttribute('data-open') === '1') return;
      hint.hidden = true;
      hint.classList.remove('is-leaving');
    }, 150);
  }

  function notifyCartUpdated() {
    try {
      document.dispatchEvent(new Event('shopify:cart:updated'));
    } catch (e) {}
    try {
      document.dispatchEvent(new Event('cart:updated'));
    } catch (e) {}
  }

  function reloadCartIfStuckOnForm(cart) {
    if (!document.body.classList.contains('template-cart')) return false;
    if (productQty(cart) > 0) return false;
    if (prioItems(cart).length > 0) return false;
    var hasForm = document.querySelector('[data-section-type="cart"] .subtotal-row, [data-section-type="cart"] .cart-items');
    if (!hasForm) return false;
    window.location.reload();
    return true;
  }

  function removeHiddenServices(cart) {
    var hidden = prioItems(cart);
    if (!hidden.length) return Promise.resolve(cart);
    var updates = {};
    for (var i = 0; i < hidden.length; i++) {
      updates[hidden[i].key] = 0;
    }
    sweeping = true;
    return fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(parseCartResponse).then(function (next) {
      sweeping = false;
      return next;
    }).catch(function (err) {
      sweeping = false;
      throw err;
    });
  }

  function sweep(cart) {
    if (sweeping) return Promise.resolve(cart);

    var run = function (c) {
      if (productQty(c) > 0) {
        syncUi(c);
        return c;
      }
      if (!prioItems(c).length) {
        syncUi(c);
        return c;
      }
      return removeHiddenServices(c).then(function (next) {
        syncUi(next);
        if (!reloadCartIfStuckOnForm(next)) notifyCartUpdated();
        return next;
      });
    };

    if (cart && cart.items) return Promise.resolve(run(cart));
    return getCart().then(run);
  }

  function t(lang) {
    return lang === 'fr'
      ? 'Nous traitons votre commande avant tout le monde!'
      : lang === 'en'
        ? 'We process your order before all others!'
        : 'Wir bearbeiten deine Bestellung vor allen anderen!';
  }

  function marketIso() {
    try {
      return (window.Shopify && Shopify.market && Shopify.market.current && Shopify.market.current.isoCode
        ? Shopify.market.current.isoCode
        : (window.Shopify && Shopify.locale ? Shopify.locale : 'de')).toLowerCase();
    } catch (e) {
      return 'de';
    }
  }

  function addVariant(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        properties: { Prio: t(marketIso()) }
      })
    }).then(parseCartResponse);
  }

  function removeVariantById(variantId) {
    return getCart().then(function (cart) {
      var it = (cart.items || []).find(function (i) {
        return String(i.variant_id) === String(variantId);
      });
      if (!it) return cart;
      return fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: it.key, quantity: 0 })
      }).then(parseCartResponse);
    });
  }

  function bindCheckbox() {
    var el = document.getElementById(CHECKBOX_ID);
    if (!el || el._mkPrioBound) return;
    el._mkPrioBound = true;
    el.addEventListener('change', function (e) {
      if (busy) return;
      var vid = e.target.getAttribute('data-variant');
      var wantOn = e.target.checked;
      busy = true;
      el.disabled = true;
      getCart().then(function (cart) {
        if (wantOn && productQty(cart) === 0) {
          e.target.checked = false;
          return cart;
        }
        return wantOn ? addVariant(vid) : removeVariantById(vid);
      }).then(function (cart) {
        return sweep(cart);
      }).then(function (cart) {
        if (productQty(cart) > 0) notifyCartUpdated();
        else reloadCartIfStuckOnForm(cart);
      }).catch(function () {
        el.checked = !wantOn;
      }).finally(function () {
        busy = false;
        getCart().then(syncUi).catch(function () {
          var box = document.getElementById(CHECKBOX_ID);
          if (box) box.disabled = false;
        });
      });
    });
  }

  function bindRemoveLinks() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('a.quantity__remove');
      if (!link) return;
      if (!document.body.classList.contains('template-cart')) return;
      if (!link.closest('[data-section-type="cart"]')) return;
      e.preventDefault();
      var url;
      try {
        url = new URL(link.getAttribute('href'), window.location.origin);
      } catch (err) {
        window.location.href = link.href;
        return;
      }
      var line = url.searchParams.get('line');
      var quantity = url.searchParams.get('quantity');
      if (line == null) {
        window.location.href = link.href;
        return;
      }
      fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
      }).then(parseCartResponse).then(function (cart) {
        return sweep(cart);
      }).then(function (cart) {
        if (productQty(cart) > 0) notifyCartUpdated();
        else reloadCartIfStuckOnForm(cart);
      }).catch(function () {
        window.location.href = link.href;
      });
    });
  }

  function bindJqueryCart() {
    if (!window.jQuery) return;
    jQuery(document).ajaxComplete(function (event, xhr, settings) {
      if (sweeping || busy) return;
      if (!settings || !settings.url) return;
      if (!/\/cart\/(change|update|add|clear)/.test(settings.url)) return;
      try {
        var cart = typeof xhr.responseJSON === 'object' ? xhr.responseJSON : JSON.parse(xhr.responseText);
        if (cart && cart.items) sweep(cart);
      } catch (err) {}
    });
  }

  function init() {
    bindCheckbox();
    bindRemoveLinks();
    bindJqueryCart();
    sweep();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
